/** Official NYC subway line colors (hex). Source: MTA brand standards. */
const HEX = {
    '1': 'EE352E', '2': 'EE352E', '3': 'EE352E',
    '4': '00933C', '5': '00933C', '6': '00933C', '5X': '00933C', '6X': '00933C',
    '7': 'B933AD', '7X': 'B933AD',
    A: '0039A6', C: '0039A6', E: '0039A6',
    B: 'FF6319', D: 'FF6319', F: 'FF6319', M: 'FF6319', FX: 'FF6319',
    G: '6CBE45',
    J: '996633', Z: '996633',
    L: 'A7A9AC',
    N: 'FCCC0A', Q: 'FCCC0A', R: 'FCCC0A', W: 'FCCC0A',
    // Shuttles (42 St, Franklin Av, Rockaway Park) — official MTA dark grey.
    S: '808183', GS: '808183', FS: '808183', H: '808183', SS: '808183',
    SI: '0039A6', SIR: '0039A6',
};
const FALLBACK = [160, 160, 160];
export function routeColor(routeId) {
    const hex = HEX[routeId] ?? HEX[routeId.toUpperCase()];
    if (!hex)
        return FALLBACK;
    return [
        parseInt(hex.slice(0, 2), 16),
        parseInt(hex.slice(2, 4), 16),
        parseInt(hex.slice(4, 6), 16),
    ];
}
